import styled from 'styled-components';

export const StyledInfoTile = styled.div`
  max-width: 800px;
  flex-basis: 50%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }): string => theme.spacing_unit_x4};
  border: ${({ theme }): string => {
    return `1px solid ${theme.palette_gray_10}`;
  }};
`;

export const FlexRowDiv = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: row;
  gap: 0.5rem;
`;
